// import Home from '@/views/stufdback/home'
const Home = () => import('@/views/stufdback/home')
// import Introduced from '@/views/stufdback/introduce'
const Introduced = () => import('@/views/stufdback/introduce')
export default [
    {
        path: '',
        component: Home,
        meta: {
            title: '帮助与反馈'
        }
    },
    {
        path: 'uxintro',
        name: 'Introduced',
        component: Introduced,
        meta: {
            title: '使用帮助'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/stufdback.js